module.exports = __webpack_public_path__ + "img/8.10.pH.b6e71921.png";